const rankings = [
  { rank: 1, title: '夏日烟火', type: '日剧', score: '9.2', hot: '本周最热' },
  { rank: 2, title: '暗夜追踪 第二季', type: '美剧', score: '9.0', hot: '口碑飙升' },
  { rank: 3, title: '长安十二时辰', type: '国产剧', score: '8.8', hot: '全集完结' },
  { rank: 4, title: '星际迷航：新纪元', type: '欧美大片', score: '8.7', hot: '新片上线' },
  { rank: 5, title: '深夜食堂 第五季', type: '日剧', score: '8.6', hot: '一次性上线' },
  { rank: 6, title: '山河令', type: '国产剧', score: '8.5', hot: '第二季预告' },
];

const rankMedals = ['text-amber-500', 'text-secondary-400', 'text-orange-400'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热播榜单
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              实时热度排行，大家都在看
            </p>
          </div>

          <div className="max-w-[720px] mx-auto">
            <div className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
              {rankings.map((item, i) => (
                <a
                  key={item.rank}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="flex items-center gap-4 px-5 py-4 hover:bg-background-100/60 transition-colors duration-200 cursor-pointer border-b border-background-200/60 last:border-b-0"
                >
                  <div className="w-8 h-8 flex items-center justify-center shrink-0">
                    {i < 3 ? (
                      <i className={`ri-medal-fill text-xl ${rankMedals[i]}`} />
                    ) : (
                      <span className="text-sm font-bold text-foreground-500">{item.rank}</span>
                    )}
                  </div>

                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-900 truncate">
                      {item.title}
                    </h4>
                    <span className="text-xs text-foreground-500">{item.type}</span>
                  </div>

                  <span className="text-sm font-heading font-bold text-primary-500 whitespace-nowrap">
                    {item.score}
                  </span>

                  <span className="hidden sm:inline-block px-2 py-0.5 text-xs font-medium rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.hot}
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}